var $0542d8f6cc689b61$exports = {};
$0542d8f6cc689b61$exports = {
    "pending": `afventende`
};


export {$0542d8f6cc689b61$exports as default};
//# sourceMappingURL=da-DK.mjs.map
